import { useEffect, useState } from 'react';
import { PersonalizedLetterCompose } from 'assets/js/pages/engage/letters/PersonalizedLetterCompose';
import { PersonalizedLetterRecipientsList } from 'assets/js/pages/engage/letters/PersonalizedLetterRecipientsList';
import * as PersonalizedLetterUnsavedChangesDialog from 'assets/js/pages/engage/letters/PersonalizedLetterUnsavedChangesDialog';
import { usePersonalizedLetterContactsQuery } from 'assets/js/pages/engage/letters/usePersonalizedLetterContactsQuery';
import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';
import { first } from 'lodash';

const PersonalizedLetters = () => {
    const {
        setCurrentPersonalizedLetterContact,
        isUnsavedChangesDialogOpen,
        setIsUnsavedChangesDialogOpen,
    } = usePersonalizedLettersStore();

    const { isFetching, data } = usePersonalizedLetterContactsQuery();
    const [didInit, setDidInit] = useState(false);

    useEffect(() => {
        if (!didInit && !isFetching) {
            const defaultContact = first(data.pages);
            if (defaultContact) {
                setCurrentPersonalizedLetterContact(defaultContact);
            } else {
                setCurrentPersonalizedLetterContact();
            }

            setDidInit(true);
        }
    }, [data.pages, didInit, isFetching, setCurrentPersonalizedLetterContact]);

    useEffect(() => {
        return () => {
            setCurrentPersonalizedLetterContact();
            setDidInit(false);
        };
    }, [setCurrentPersonalizedLetterContact]);

    return (
        <>
            <div
                className={
                    '-my-6 flex flex-wrap overflow-y-auto md:flex-nowrap md:overflow-y-hidden'
                }
            >
                <div
                    className={
                        'md:w-[320px] md:min-w-[320px] md:border-r md:border-r-gray-200 lg:w-[480px] lg:min-w-[480px] [&>*]:h-screen [&>*]:min-h-svh'
                    }
                >
                    <PersonalizedLetterRecipientsList />
                </div>
                <div className={'w-full'}>
                    <PersonalizedLetterCompose />
                </div>
            </div>
            <PersonalizedLetterUnsavedChangesDialog.Root
                open={isUnsavedChangesDialogOpen}
                onOpenChange={open => setIsUnsavedChangesDialogOpen(open)}
            />
        </>
    );
};

export { PersonalizedLetters };
